module.exports = __webpack_public_path__ + "static/plug-c319f09aaa5f6bcf4d7a3c4c4095086f.mp4";